import { useEffect } from "react";
import { Button, LaptopIcon, Message01Icon } from "@porchpass/ui";
import { Col } from "src/components/layout";
import { SlideUpModal } from "src/components/SlideUpModal";
import { useWebClientApi } from "src/api";
import { useDlaFormSubmit } from "src/hooks/useDlaFormSubmit";

type AddCoborrowerModalProps = {
  isOpen: boolean;
  closeHandler: () => void;
  confirmHandler: (_: boolean) => void;
};

export default ({
  isOpen,
  closeHandler,
  confirmHandler,
}: AddCoborrowerModalProps) => {
  const api = useWebClientApi();
  const [submitHandler, loading, response] = useDlaFormSubmit(() =>
    api.createCoborrower(),
  );

  useEffect(() => {
    if (response) {
      confirmHandler(true);
    }
  }, [response]);

  return (
    <SlideUpModal
      title="How would you like to add your co-borrower?"
      isOpen={isOpen}
      closeHandler={closeHandler}
      hasDismissButton={false}
      dismissible
      showCloseButton
      isLoading={loading}
    >
      <Col>
        <br></br>
        <Button
          type="button"
          variant="secondary"
          className="h-auto w-full justify-start gap-4 rounded-2xl px-4 py-4"
          onClick={() => void submitHandler({})}
        >
          <LaptopIcon
            variant="bulk-rounded"
            size={20}
            className="text-primary"
          />
          <div className="flex flex-col items-start text-left">
            <span className="text-base font-medium">This Device</span>
            <span className="text-xs font-normal text-on-surface-muted">
              Keep using this device to add a co-borrower.
            </span>
          </div>
        </Button>
        <Button
          type="button"
          variant="secondary"
          className="h-auto w-full justify-start gap-4 rounded-2xl px-4 py-4"
          onClick={() => confirmHandler(false)}
        >
          <Message01Icon
            variant="bulk-rounded"
            size={20}
            className="text-primary"
          />
          <div className="flex flex-col items-start text-left">
            <span className="text-base font-medium">Send invitation</span>
            <span className="text-xs font-normal text-on-surface-muted">
              Invite a co-borrower to use their device.
            </span>
          </div>
        </Button>
        <br></br>
      </Col>
    </SlideUpModal>
  );
};
